export const SUPPORTED_LANGUAGES = ['en', 'he', 'de'] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value)
}

/** UI languages temporarily hidden from the picker (still valid internally). */
export const HIDDEN_UI_LANGUAGES = ['de'] as const satisfies readonly SupportedLanguage[]
